import { BKJButtonIconTextInput } from '@awais4123/fillify-design-library';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { BKJToggleInput } from '@awais4123/fillify-design-library';
import { Flex } from 'components/Flex';
import { JaneGridSelect } from 'components/JaneGridSelect';
import { QuerySwitch } from 'components/QuerySwitch';
import { useShiftModalDataContext } from 'components/ShiftModal/ShiftModalProvider.data.context';
import {
  EstimatedTotalPayoutFooterText,
  InfoSection,
  RequestTeamMemberWrapper,
  SendToAgenciesBoldText,
  SendToAgenciesText,
  SendToAgenciesViewTitle,
  HeaderWrapper,
  SendToAgenciesViewTitleContainer,
  TotalAvailableJanesText,
  ConfirmationButtons,
} from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.styled';
import { FC, Fragment, useCallback, useState } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { AutoMargin } from 'components/AutoMargin';
import { RequestTeamMemberFilterBar } from 'components/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/RequestTeamMemberFilterBar';
import { PriceFilter } from 'components/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/RequestTeamMemberView.styled';
import { useSendToAgenciesPropsContext } from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.props.context';
import { useSendToAgenciesFormContext } from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import {
  FetchTeamMembersDataContext,
  useFetchTeamMembersDataContext,
} from 'components/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/contexts/FetchTeamMembers.data.context';
import { useFetchMinMaxPricesByPositionIdDataContext } from 'components/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/contexts/FetchMinMaxPricesByPositionId.data.context';
import { useFetchTeamMemberByJaneIdDataContext } from 'components/ShiftModal/src/views/SendToAgenciesView/RequestTeamMemberView/contexts/FetchTeamMemberByJaneId.data.context';
import { UseFormBehaviorsEventType } from 'hooks/useFormBehaviors/useFormBehaviors.types';
import {
  parsePrice,
  priceFormatter,
} from 'components/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/SendToAgenciesSummaryView.constants';
import { FormatCurrency } from 'components/FormatCurrency';

function RenderJanes() {
  const { onChange: onChangeForm, values } = useSendToAgenciesFormContext();
  const { loadMore } = useFetchTeamMembersDataContext();
  const { onChange: onChangeFetchTeamMemberByJaneId } = useFetchTeamMemberByJaneIdDataContext();

  const onChange = (e: UseFormBehaviorsEventType) => {
    onChangeForm(e);
    onChangeFetchTeamMemberByJaneId(e);
  };

  return (
    <JaneGridSelect
      edgeCaseType="SendToAgencies"
      paginationType="InfiniteScroll"
      type="Single"
      name="jane_id"
      dataPath="requestJanes.nodes"
      value={[values.jane_id]}
      context={FetchTeamMembersDataContext}
      onChange={onChange}
      loadMore={loadMore}
      pageInfoDataPath="requestJanes.pageInfo"
    />
  );
}

function RenderDedicatedToggle() {
  const { t } = useTranslation();
  const { onChange: onChangeForm, values } = useSendToAgenciesFormContext();
  const { onChange } = useFetchTeamMembersDataContext();

  const toggleDedicated = useCallback(
    (onToggle) => {
      onChangeForm([onToggle, { target: { name: 'jane_id', value: '' } }]);
      onChange(onToggle);
    },
    [onChangeForm, onChange],
  );
  return (
    <InfoSection gap="8px" alignItems="center">
      <Flex alignItems="center" justifyContent="space-between" width="100%">
        <SendToAgenciesBoldText>
          {t('shift_modal:SEND_TO')}:&nbsp;
          <SendToAgenciesText>{t('shift_modal:ONLY_DEDICATED_TEAM_MEMBERS')}</SendToAgenciesText>
          &nbsp;&nbsp;&nbsp;&nbsp;
        </SendToAgenciesBoldText>
        <BKJToggleInput
          name="isDedicated"
          variant="Switch"
          checked={values.isDedicated}
          onChange={toggleDedicated}
        />
      </Flex>
    </InfoSection>
  );
}

const RenderSSFControls: FC = () => {
  const { t } = useTranslation();
  const { data } = useFetchMinMaxPricesByPositionIdDataContext();
  const { values, onChange } = useFetchTeamMembersDataContext();

  const { min, max } = data;

  const [isOpen, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!isOpen);
  }, [isOpen]);

  return (
    <Flex flexDirection="column">
      <BKJButtonIconTextInput
        placeholder={t('shift_modal:SEARCH_MEMBER')}
        buttonLabel={t('shift_modal:FILTERS')}
        name="byFullName"
        iconName="Search"
        buttonIcon="Filters"
        value={values.byFullName}
        onChange={onChange}
        onButtonClick={handleClick}
        autoComplete="off"
        label=""
        required={false}
        error={''}
        disabled={false}
      />
      <RequestTeamMemberFilterBar isOpen={isOpen}>
        {/* Commenting out the Agency Filter. Scoped out for J360 V1. */}
        {/* <AgencyFilterInput
          dropdownVariant="Square"
          placeholder="Agency"
          type="Multiple"
          variant="GreyOutlinedPillClear"
          name="byAgency"
          onChange={onChange}
          value={values.byAgency}
        /> */}
        <PriceFilter
          priceRange={[min, max]}
          name="byRateLessThanOrEqualTo"
          value={values.byRateLessThanOrEqualTo}
          onChange={onChange}
        />
      </RequestTeamMemberFilterBar>
    </Flex>
  );
};

export function RequestTeamMemberViewComponent() {
  const { t } = useTranslation();
  const { data } = useShiftModalDataContext();
  const { values } = useSendToAgenciesFormContext();
  const { goToNextView } = useSendToAgenciesPropsContext();
  const { data: requestTeamMemberCountData } = useFetchTeamMembersDataContext();

  const { data: fetchTeamMemberByJaneIdData } = useFetchTeamMemberByJaneIdDataContext();

  const estimatedPayout =
    fetchTeamMemberByJaneIdData?.fetchJane.positions[0].agencyDetails?.openRate || '';

  const estimatedTotalPayout = estimatedPayout
    ? priceFormatter.format(data.fetchOrder!.totalDuration! * parsePrice(estimatedPayout))
    : '';

  return (
    <Fragment>
      <HeaderWrapper>
        <SendToAgenciesViewTitleContainer alignItems="center" justifyContent="space-between">
          <SendToAgenciesViewTitle css="margin-bottom: 0;">
            {t('shift_modal:REQUEST_AGENCY_MEMBER')}
          </SendToAgenciesViewTitle>
          {requestTeamMemberCountData && (
            <TotalAvailableJanesText>
              {`${requestTeamMemberCountData.requestJanes.totalCount} ${t(
                'shift_modal:AVAILABLE',
              )}`}
            </TotalAvailableJanesText>
          )}
        </SendToAgenciesViewTitleContainer>

        {data.fetchOrder!.dedicatedPool && <RenderDedicatedToggle />}

        <RenderSSFControls />
      </HeaderWrapper>

      <RequestTeamMemberWrapper
        flexDirection="column"
        padding="24px 32px"
        flex="1"
        height="100%"
        width="100%"
      >
        <QuerySwitch component={RenderJanes} context={FetchTeamMembersDataContext} />
      </RequestTeamMemberWrapper>
      <BKJSideModalFooter>
        <EstimatedTotalPayoutFooterText disabled={!estimatedTotalPayout}>
          {t('shift_modal:ESTIMATED_PAYOUT')}:
          <FormatCurrency amount={`${estimatedTotalPayout || '0.00'}`} />
        </EstimatedTotalPayoutFooterText>
        <AutoMargin />
        <ConfirmationButtons
          width="180px"
          variant="PurpleSolid"
          onClick={goToNextView}
          disabled={!values.jane_id}
        >
          {t('shift_modal:NEXT')}
        </ConfirmationButtons>
      </BKJSideModalFooter>
    </Fragment>
  );
}
